export interface MailAddress {
  name: string;
  address: string | null;
}

export interface MailPreviewAttachment {
  index: number;
  filename: string;
  content_type: string | null;
  size: number;
  is_inline: boolean;
}

export interface MailPreview {
  subject: string;
  sender: MailAddress;
  to: MailAddress[];
  cc: MailAddress[];
  sent_on: string | null;
  body_html: string;
  attachments: MailPreviewAttachment[];
  truncated_images: number;
}

export const MAIL_FILE_EXTENSIONS = ["eml", "msg"];

export function formatMailAddress(address: MailAddress): string {
  if (!address) {
    return "";
  }
  if (address.name && address.address) {
    return `${address.name} <${address.address}>`;
  }
  return address.name || address.address || "";
}
